import { useState } from "react";
import { Braces, Copy } from "lucide-react";
import { toast } from "sonner";

export const JsonPanel = ({ data }) => {
  const [open, setOpen] = useState(true);
  const json = JSON.stringify(data, null, 2);
  const copy = async () => {
    await navigator.clipboard?.writeText(json);
    toast.success("JSON copiado");
  };
  return (
    <section data-testid="json-panel" className="rounded-xl border border-zinc-800 bg-[#121215] p-4 space-y-2">
      <div className="flex items-center justify-between">
        <button data-testid="json-toggle-btn" onClick={() => setOpen(!open)} className="flex items-center gap-2 font-mono text-[10px] tracking-[0.2em] uppercase text-zinc-400 hover:text-cyan-400 transition-colors">
          <Braces className="w-4 h-4" /> JSON crudo {open ? "▾" : "▸"}
        </button>
        <button data-testid="json-copy-btn" onClick={copy} className="p-1.5 rounded text-zinc-500 hover:text-cyan-400 transition-colors" aria-label="Copiar JSON">
          <Copy className="w-4 h-4" />
        </button>
      </div>
      {open && (
        <pre data-testid="json-raw" className="text-[11px] font-mono leading-snug text-zinc-300 bg-black/60 border border-zinc-900 rounded-md p-3 overflow-x-auto max-h-[480px]">
          {json}
        </pre>
      )}
    </section>
  );
};
